import {
   Button,
   Flex,
   Icon,
   Menu,
   MenuButton,
   MenuItem,
   MenuList,
   Text,
   useColorModeValue,
   useColorMode,
   useBreakpointValue,
   Drawer,
   DrawerBody,
   DrawerHeader,
   DrawerOverlay,
   DrawerContent,
   Table,
   Tbody,
   Tr,
   Td,
   useDisclosure,
   Box,
   Tooltip,
   Avatar,
   MenuDivider,
   Skeleton,
   SkeletonCircle,
   Select,
   Spinner,
} from '@chakra-ui/react';
// Custom Components
import { SidebarResponsive } from 'components/sidebar/Sidebar';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useMemo } from 'react';
// Assets
import {
   MdOutlineKeyboardArrowRight,
   MdOutlineSpaceBar,
   MdFeedback,
   MdBackup,
   MdNotificationsActive,
} from 'react-icons/md';
import { IoIosSend, IoLogoWhatsapp, IoMdMoon, IoMdSunny } from 'react-icons/io';
import routes from 'routes';
import { useState } from 'react';
import { FaCaretDown, FaCheck, FaEye, FaEyeSlash, FaFacebookMessenger, FaRegKeyboard } from 'react-icons/fa';
import { BiSupport } from 'react-icons/bi';
import { IoLogoWechat } from 'react-icons/io5';
import FeedbackForm from 'views/admin/default/components/Feedback';
import { AiOutlineMenuFold, AiOutlineMenuUnfold } from 'react-icons/ai';
import Sidebar from 'components/sidebar/Sidebar';
import IconSidebar from 'components/sidebar/IconSidebar';
import { useLocation, useNavigate } from 'react-router-dom';
import { ChevronDownIcon, EditIcon } from '@chakra-ui/icons';
import { Clock, LockIcon, Sparkles } from 'lucide-react';
import { logout } from 'utils/auth';
import { useDispatch, useSelector } from 'react-redux';
import {
   getUser,
   resetUserPassword,
   sendOtpInEmailOrNo,
   updateUser,
   updateUserFinancialYear,
   userProfile,
} from '../../redux/actions/user';
import { updateCustomer } from '../../redux/actions/customer';
import { getFinancialYears } from '../../redux/actions/dashboard';
import { backupDatabase } from '../../redux/actions/utility';
import { getCurrentFinancialYear } from 'utils/util';
import { toast } from 'react-toastify';
import { SearchBarGlobal } from './searchBar/SearchBarGlobal';
import PackageExpiredModal from './PackageExpiredModal';
import { GiNetworkBars } from 'react-icons/gi';
import { filterRoutes } from '../../utils/util';
import NotifyMe from './NofifyMe';
import { useGlobal, useBusinessType } from '../../contexts';
import PlanCarousel from 'components/ZeronineWebsite/PlanCarousel';
import Notification from './Notification';
import { getNotification } from '../../redux/actions/notifyMe';
import { HiOutlineRefresh } from 'react-icons/hi';
import { getAccount } from '../../redux/actions/account';
import { getDaybook } from '../../redux/actions/daybook';
import { getItem } from '../../redux/actions/item';


export default function HeaderLinks(props) {
   // const [isOpen, setIsOpen] = useState(false);
   const location = useLocation();
   const currentUrl = location.pathname;
   const { colorMode, toggleColorMode } = useColorMode();
   const { isOpen, onOpen, onClose } = useDisclosure();
   const navigate = useNavigate();
   const { company } = useGlobal();

   // Theme detection
   const isDark = colorMode === 'dark';

   // Chakra Color Mode
   const [isOpenProfile, setIsOpenProfile] = useState(false);
   const [searchTerm, setSearchTerm] = useState('');
   const isMobile = useBreakpointValue({ base: true, sm: true, md: true, lg: true, xl: false });
   const [isMenuOpen, setIsMenuOpen] = useState(false);
   const [toDate, setToDate] = useState(null);
   const [fromDate, setFromDate] = useState(null);
   const dispatch = useDispatch();
   const buttonRef = useRef(null);
   const imageModalRef = useRef(null);
   const [isFeedbackOpen, setIsFeedbackOpen] = useState(false);
   const option = useSelector((state) => state?.dashboard?.financialYears);
   const [selectedFinancialYear, setSelectedFinancialYear] = useState('');
   const [showOtpModal, setShowOtpModal] = useState(false);
   const [otpValue, setOtpValue] = useState(['', '', '', '', '', '']);
   const [pendingUpdate, setPendingUpdate] = useState(null);
   const [otpLoading, setOtpLoading] = useState(false);
   const otpRefs = useRef([]);
   const [isEditingName, setIsEditingName] = useState(false);
   const [isEditingMobile, setIsEditingMobile] = useState(false);
   const [editedName, setEditedName] = useState('');
   const [editedMobile, setEditedMobile] = useState('');
   const user = useSelector((state) => state.user?.profile);
   const activeUserPackage = user?.packageData?.find((pkg) => pkg.status === true);
   const shouldShowExpiryWarning = activeUserPackage?.expireInDays <= 7 && activeUserPackage?.expireInDays > 0;
   const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);
   const [isNotifyMeOpen, setIsNotifyMeOpen] = useState(false);
   const [isNotification, setIsNotification] = useState(false);
   const [showUpgrade, setShowUpgrade] = useState(false);
   const [currentPlan, setCurrentPlan] = useState(null);
   const [isRefreshing, setIsRefreshing] = useState(false);
   const [isOnline, setIsOnline] = useState(navigator.onLine);
   const [networkSpeed, setNetworkSpeed] = useState('good');
   const [passwordData, setPasswordData] = useState({
      oldPassword: '',
      newPassword: '',
      confirmPassword: '',
   });
   const [showPasswords, setShowPasswords] = useState({
      old: false,
      new: false,
      confirm: false,
   });
   const [passwordErrors, setPasswordErrors] = useState({});
   const [isSubmitting, setIsSubmitting] = useState(false);
   const [isTwoFA, setIsTwoFA] = useState(false);
   const isAdmin = user?.isAdmin === true;
   const userRights = user?.userRights?.map(ur => ur.companyId === user?.loginhistory?.companyId);
   const { userGlobalSettingsData } = useGlobal();
   const authToken = localStorage.getItem('authTokenCustomer');
   const isAccount = useMemo(
      () => userGlobalSettingsData?.[0]?.askCompany?.account || false || false,
      [userGlobalSettingsData],
   );
   const isItem = useMemo(() => {
      return userGlobalSettingsData?.[0]?.askCompany?.item || false;
   }, [userGlobalSettingsData]);
   const isDaybook = useMemo(() => userGlobalSettingsData?.[0]?.askCompany?.daybook || false, [userGlobalSettingsData]);
   const filterRoutesData = filterRoutes(routes, user, company?.setting);
   const PackageData = useSelector((state) => state.Package?.list || []);

   useEffect(() => {
      if (user && activeUserPackage) {
         setCurrentPlan(activeUserPackage?.pId || null);
      }
   }, [user, activeUserPackage]);
   useEffect(() => {
      const activePackage = user?.packageData?.find((pkg) => pkg.status === true);
      if (activePackage) {
         setCurrentPlan(activePackage.pId);
      }
   }, [user, user?.packageData]);

   const notificationData = useSelector((state) => state?.NotifyMe?.Notification) || [];
   const Paginationdata = useSelector((state) => state?.NotifyMe?.pagination);

   useEffect(() => {
      dispatch(getNotification({ companyId: user?.loginhistory?.companyId }));
   }, [dispatch, user?.loginhistory?.companyId]);

   // Loading states
   const [isUserLoading, setIsUserLoading] = useState(true);
   const [isFinancialYearsLoading, setIsFinancialYearsLoading] = useState(true);

   useEffect(() => {
      if (user) {
         setIsUserLoading(false);
         const isFreshSession = sessionStorage.getItem('hasActiveSession') !== 'true';
         const hasNeverSeenShortcuts = localStorage.getItem('hasSeenShortcuts') !== 'true';

         if (isFreshSession || hasNeverSeenShortcuts) {
            onOpen(); // Show shortcuts
            sessionStorage.setItem('hasActiveSession', 'true'); // Mark this session as active
            localStorage.setItem('hasSeenShortcuts', 'true'); // Mark as seen globally
         }
      }
   }, [user, onOpen]);

   useEffect(() => {
      if (user) {
         setIsTwoFA(user.web2Factor);
      }
   }, [user]);

   const handleLogout = () => {
      sessionStorage.removeItem('hasActiveSession'); // Clear session flag on logout
      logout();
      navigate('/auth/sign-in');
      window.location.reload();
   };

   useEffect(() => {
      const fetchData = async () => {
         try {
            setIsUserLoading(true);
            await dispatch(getUser());
            // await dispatch(getCompanies());
         } catch (error) {
            console.error('Error fetching data:', error);
         } finally {
            setIsUserLoading(false);
         }
      };

      fetchData();
   }, [dispatch]);

   useEffect(() => {
      // if (option.length > 0) {
      //    setSelectedFinancialYear(option[0].financial_year);
      //    localStorage.setItem('selectedFinancialYear', option[0].financial_year);
      //    localStorage.setItem('selectedFy_start_date', option[0].fy_start_date);
      //    localStorage.setItem('selectedFy_end_date', option[0].fy_end_date);
      //    setIsFinancialYearsLoading(false);
      // }

      if (user?.financialYear) {
         setSelectedFinancialYear(user?.financialYear);
         // localStorage.setItem('selectedFinancialYear', user?.financialYear);
         // localStorage.setItem('selectedFy_start_date', user?.fy_start_date);
         // localStorage.setItem('selectedFy_end_date', user?.fy_end_date);
         setIsFinancialYearsLoading(false);
      }
   }, [user?.financialYear]);

   // ESC key handler for Profile Modal
   useEffect(() => {
      const handleEscKey = (event) => {
         if (event.key === 'Escape' && isOpenProfile) {
            setIsOpenProfile(false);
         }
      };

      if (isOpenProfile) {
         document.addEventListener('keydown', handleEscKey);
         // Prevent background scroll when modal is open
         document.body.style.overflow = 'hidden';
      }

      return () => {
         document.removeEventListener('keydown', handleEscKey);
         document.body.style.overflow = 'unset';
      };
   }, [isOpenProfile]);

   // ESC key handler for OTP Modal
   useEffect(() => {
      const handleEscKey = (event) => {
         if (event.key === 'Escape' && showOtpModal) {
            handleCancelOtpVerification();
         }
      };

      if (showOtpModal) {
         document.addEventListener('keydown', handleEscKey);
         document.body.style.overflow = 'hidden';
      }

      return () => {
         document.removeEventListener('keydown', handleEscKey);
         document.body.style.overflow = 'unset';
      };
   }, [showOtpModal]);

   // ESC key handler for Password Modal
   useEffect(() => {
      const handleEscKey = (event) => {
         if (event.key === 'Escape' && isPasswordModalOpen) {
            handlePasswordModalClose();
         }
      };

      if (isPasswordModalOpen) {
         document.addEventListener('keydown', handleEscKey);
         document.body.style.overflow = 'hidden';
      }

      return () => {
         document.removeEventListener('keydown', handleEscKey);
         document.body.style.overflow = 'unset';
      };
   }, [isPasswordModalOpen]);

   useEffect(() => {
      if (user?.loginhistory?.companyId) {
         setIsFinancialYearsLoading(true);
         dispatch(getFinancialYears({ companyId: user?.loginhistory?.companyId })).finally(() => {
            setIsFinancialYearsLoading(false);
         });
      }
   }, [user?.loginhistory?.companyId, dispatch]);

   useEffect(() => {
      const handleOnline = () => {
         setIsOnline(true);
         setNetworkSpeed('good');
      };

      const handleOffline = () => {
         setIsOnline(false);
         setNetworkSpeed('offline');
         toast({
            title: 'No Internet Connection',
            description: 'Please check your internet connection',
            status: 'error',
            duration: 5000,
            isClosable: true,
         });
      };

      // No periodic checks - just listen to online/offline events
      window.addEventListener('online', handleOnline);
      window.addEventListener('offline', handleOffline);

      // Initial check
      if (navigator.onLine) {
         setIsOnline(true);
         setNetworkSpeed('good');
      } else {
         setIsOnline(false);
         setNetworkSpeed('offline');
         toast({
            title: 'No Internet Connection',
            description: 'Please check your internet connection',
            status: 'error',
            duration: 5000,
            isClosable: true,
         });
      }

      return () => {
         window.removeEventListener('online', handleOnline);
         window.removeEventListener('offline', handleOffline);
      };
   }, []);

   async function handleFinancialYearChange(selectedYear) {
      setSelectedFinancialYear(selectedYear);
      localStorage.setItem('selectedFinancialYear', selectedYear);

      await dispatch(updateUserFinancialYear(selectedYear));

      // Find the selected financial year object from the options array
      const selectedYearData = option.find((year) => year.financial_year === selectedYear);

      if (selectedYearData) {
         // Store the start and end dates in localStorage
         localStorage.setItem('selectedFy_start_date', selectedYearData.fy_start_date);
         localStorage.setItem('selectedFy_end_date', selectedYearData.fy_end_date);

         // Optional: Also update state if you're using these dates elsewhere
         setFromDate(selectedYearData.fy_start_date);
         setToDate(selectedYearData.fy_end_date);
      }
      await dispatch(userProfile());
   }

   const handleOpenNotify = () => {
      setIsNotifyMeOpen(true);
   };
   const handleOpenNotification = () => {
      setIsNotification(true);
   };

   const handleMastersRefresh = async () => {
      setIsRefreshing(true);

      try {
         const promises = [];

         if (user && user?.loginhistory?.companyId && authToken) {
            const payload = {
               compId: user?.loginhistory?.companyId,
               accountTypes: 'K,E,C,D,BROKER,I,L,M,N,A',
               status: true,
               sortBy: 'name',
               sortOrder: 'asc',
            };
            if (isAccount) {
               payload.companyIds = user?.loginhistory?.companyId;
            }
            promises.push(dispatch(getAccount(payload)));
         }

         if (user?.loginhistory?.companyId && authToken) {
            const payload = { companyId: user?.loginhistory?.companyId, sortBy: 'name', sortOrder: 'asc' };
            if (isItem) {
               payload.companyIds = user?.loginhistory?.companyId;
            }
            promises.push(dispatch(getItem(payload)));
         }

         if (user && user?.loginhistory?.companyId && authToken) {
            const payload = { companyId: user?.loginhistory?.companyId };
            if (isDaybook) {
               payload.companyIds = user?.loginhistory?.companyId;
            }
            promises.push(dispatch(getDaybook(payload)));
         }

         // Wait for all API calls to complete
         await Promise.all(promises);
      } catch (error) {
         console.error('Error refreshing masters:', error);
      } finally {
         setIsRefreshing(false);
      }
   };
   const handleUpgrade = (planId) => {
      setCurrentPlan(planId);
      setShowUpgrade(false);
   };
   // Password change functions
   const handlePasswordChange = (field, value) => {
      setPasswordData((prev) => ({
         ...prev,
         [field]: value,
      }));

      // Clear error for this field when user starts typing
      if (passwordErrors[field]) {
         setPasswordErrors((prev) => ({
            ...prev,
            [field]: '',
         }));
      }
   };

   const validatePasswords = () => {
      const errors = {};

      if (!passwordData.oldPassword) {
         errors.oldPassword = 'Current password is required';
      }

      if (!passwordData.newPassword) {
         errors.newPassword = 'New password is required';
      } else if (passwordData.newPassword.length < 6) {
         errors.newPassword = 'Password must be at least 6 characters long';
      }

      if (!passwordData.confirmPassword) {
         errors.confirmPassword = 'Please confirm your new password';
      } else if (passwordData.newPassword !== passwordData.confirmPassword) {
         errors.confirmPassword = 'Passwords do not match';
      }

      if (
         passwordData.oldPassword &&
         passwordData.newPassword &&
         passwordData.oldPassword === passwordData.newPassword
      ) {
         errors.newPassword = 'New password must be different from current password';
      }

      setPasswordErrors(errors);
      return Object.keys(errors).length === 0;
   };

   const handlePasswordSubmit = async () => {
      if (!validatePasswords()) {
         return;
      }

      setIsSubmitting(true);

      try {
         const formData = {
            email: user?.email,
            oldPassword: passwordData.oldPassword,
            newPassword: passwordData.newPassword,
         };

         await dispatch(resetUserPassword(formData));

         // Reset form and close modal on success
         setPasswordData({
            oldPassword: '',
            newPassword: '',
            confirmPassword: '',
         });
         setIsPasswordModalOpen(false);
      } catch (error) {
         console.error('Password change error:', error);
      } finally {
         setIsSubmitting(false);
      }
   };

   const togglePasswordVisibility = (field) => {
      setShowPasswords((prev) => ({
         ...prev,
         [field]: !prev[field],
      }));
   };

   const handlePasswordModalClose = () => {
      setIsPasswordModalOpen(false);
      setPasswordData({
         oldPassword: '',
         newPassword: '',
         confirmPassword: '',
      });
      setPasswordErrors({});
      setShowPasswords({
         old: false,
         new: false,
         confirm: false,
      });
   };

   const getRouteSpecificShortcuts = (currentPath) => {
      const allShortcuts = [
         { name: 'Global Search', shortcut: 'CTRL+', category: ['global'] },
         { name: 'Dashboard', shortcut: 'ALT+D', category: ['global'] },

         { name: 'Sales', shortcut: 'SS', category: ['sales', 'global'] },
         { name: 'Sales Detail', shortcut: 'ALT+S', category: ['sales', 'global'] },
         { name: 'Sales Invoice', shortcut: 'i', category: ['sales'] },
         { name: 'Sales Return', shortcut: 'r', category: ['sales'] },

         { name: 'Purchase', shortcut: 'PP', category: ['purchase', 'global'] },
         { name: 'Purchase Detail', shortcut: 'ALT+P', category: ['purchase', 'global'] },
         { name: 'Purchase Invoice', shortcut: 'i', category: ['purchase'] },
         { name: 'Purchase Return', shortcut: 'r', category: ['purchase'] },

         { name: 'Inventory', shortcut: 'ALT+I', category: ['inventory', 'global'] },
         { name: 'Issue', shortcut: 'i', category: ['inventory'] },
         { name: 'Receive', shortcut: 'r', category: ['inventory'] },
         { name: 'Stock Transfer', shortcut: 's', category: ['inventory'] },

         { name: 'Customers', shortcut: currentPath?.includes('/master') ? 'ALT+M / c' : 'ALT+M', category: ['master', 'global'] },
         { name: 'Vendors', shortcut: 'v', category: ['master'] },
         { name: 'All Account', shortcut: 'a', category: ['master'] },
         { name: 'Item', shortcut: 'i', category: ['master'] },
         { name: 'Group', shortcut: currentPath?.includes('/master') ? 'LL / g' : 'LL', category: ['master', 'global'] },
         { name: 'Daybook', shortcut: 'd', category: ['master'] },
         { name: 'Bank Branch', shortcut: 'b', category: ['master'] },
         { name: 'Transport', shortcut: 't', category: ['master'] },
         { name: 'Other', shortcut: 'o', category: ['master'] },

         { name: 'Journal Vouchers', shortcut: 'JJ / ALT+J', category: ['accounts', 'global'] },
         { name: 'Cash', shortcut: 'CC / ALT+C', category: ['accounts', 'global'] },
         { name: 'Bank', shortcut: 'BB / ALT+B', category: ['accounts', 'global'] },

         { name: 'Reports', shortcut: 'ALT+R', category: ['reports', 'global'] },
         { name: 'Balance Sheet', shortcut: 'CTRL+B', category: ['reports'] },
         { name: 'Profit & Loss', shortcut: 'CTRL+I', category: ['reports'] },
         { name: 'Stock Report', shortcut: 'ii', category: ['reports', 'global'] },
         { name: 'Outstanding', shortcut: 'OS', category: ['reports', 'global'] },
         { name: 'Sales Details', shortcut: 'shift+s', category: ['reports'] },
         { name: 'Purchase Details', shortcut: 'shift+p', category: ['reports'] },
      ];

      let routeCategory = 'global';

      if (currentPath.includes('/sales')) {
         routeCategory = 'sales';
      } else if (currentPath.includes('/purchase')) {
         routeCategory = 'purchase';
      } else if (
         currentPath.includes('/inventory') ||
         currentPath.includes('/stock') ||
         currentPath.includes('/issue') ||
         currentPath.includes('/receive') ||
         currentPath.includes('/transfer')
      ) {
         routeCategory = 'inventory';
      } else if (
         currentPath.includes('/master') ||
         currentPath.includes('/customers') ||
         currentPath.includes('/ledger')
      ) {
         routeCategory = 'master';
      } else if (
         currentPath.includes('/accounts') ||
         currentPath.includes('/cash') ||
         currentPath.includes('/bank') ||
         currentPath.includes('/journal')
      ) {
         routeCategory = 'accounts';
      } else if (
         currentPath.includes('/report') ||
         currentPath.includes('/balance-sheet') ||
         currentPath.includes('/profit-loss')
      ) {
         routeCategory = 'reports';
      } else if (currentPath === '/admin/default' || currentPath === '/admin' || currentPath === '/') {
         routeCategory = 'global';
      }

      const allowedCategories = ['global', routeCategory];

      return allShortcuts.filter((shortcut) => shortcut.category.some(cat => allowedCategories.includes(cat)));
   };

   const routeSpecificShortcuts = getRouteSpecificShortcuts(currentUrl);
   const filteredShortcuts = routeSpecificShortcuts.filter(
      (shortcut) =>
         shortcut.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
         shortcut.shortcut.toLowerCase().includes(searchTerm.toLowerCase()),
   );

   const handleOpenModal = () => {
      setIsFeedbackOpen(true);
   };

   const handleBackup = () => {
      dispatch(backupDatabase());
   };

   const handleCloseModal = () => {
      setIsFeedbackOpen(false);
   };

   const toggleSidebars = () => {
      props.setIsSidebarOpen((prev) => !prev);
      // setIsSidebarOpen(newState);
   };

   useEffect(() => {
      if (user && user?.financialYear) {
         setSelectedFinancialYear(user?.financialYear);
         const selectfyYear = option?.find((fy) => fy?.financial_year === user?.financialYear);
         localStorage.setItem('selectedFinancialYear', selectfyYear?.financial_year);
         localStorage.setItem('selectedFy_start_date', selectfyYear?.fy_start_date);
         localStorage.setItem('selectedFy_end_date', selectfyYear?.fy_end_date);
      }
      if (user && user?.financialYear === null) {
         const financialYear = getCurrentFinancialYear();
         dispatch(updateUserFinancialYear(financialYear));
      }
      return () => { };
   }, [dispatch, user, option]);

   const handleToggleTwoFA = async (checked) => {
      // setIsTwoFA(checked);
      await dispatch(updateCustomer({ id: user.id, mobile: user.mobile, email: user.email, web2Factor: checked }));
      await dispatch(userProfile());
   };
   const handleEditName = () => {
      setEditedName(user?.name || '');
      setIsEditingName(true);
   };

   const handleCancelEditName = () => {
      setEditedName('');
      setIsEditingName(false);
   };

   // Handler functions for mobile editing
   const handleEditMobile = () => {
      setEditedMobile(user?.mobile || '');
      setIsEditingMobile(true);
   };

   const handleSaveMobile = async () => {
      const error = editedMobile.trim() === '' ? 'Mobile number cannot be empty' : null;
      if (error) {
         toast({ title: 'Error', description: error, status: 'error', duration: 3000, isClosable: true });
         return;
      }

      // Store the pending update
      setPendingUpdate({
         id: user?.id,
         fieldConfig: {
            value: editedMobile,
            fieldName: 'mobile',
            setIsEditing: setIsEditingMobile,
         },
      });

      // Send OTP
      try {
         setOtpLoading(true);
         await dispatch(
            sendOtpInEmailOrNo({
               email: user?.email,
               sendType: 0,
            }),
         );

         toast({
            title: 'OTP Sent',
            description: 'Please check your email for the verification code',
            status: 'success',
            duration: 3000,
            isClosable: true,
         });

         // Reset OTP values and show modal
         setOtpValue(['', '', '', '', '', '']);
         setShowOtpModal(true);
      } catch (error) {
         console.error('Error sending OTP:', error);
         toast({
            title: 'Error',
            description: 'Failed to send OTP. Please try again.',
            status: 'error',
            duration: 3000,
            isClosable: true,
         });
      } finally {
         setOtpLoading(false);
      }
   };

   // Updated handleSaveField function
   const handleSaveField = async (id, fieldConfig) => {
      const { value, fieldName, validationFn, updateAction, setIsEditing } = fieldConfig;
      const error = validationFn ? validationFn(value, fieldName) : null;

      if (error) {
         toast({
            title: 'Error',
            description: error,
            status: 'error',
            duration: 3000,
            isClosable: true,
         });
         return;
      }

      // If changing name or mobile, require OTP verification
      if (fieldName.toLowerCase() === 'name' || fieldName.toLowerCase() === 'mobile') {
         // Store the pending update
         setPendingUpdate({ id, fieldConfig });

         // Send OTP
         try {
            setOtpLoading(true);
            await dispatch(
               sendOtpInEmailOrNo({
                  email: user?.email,
                  sendType: 0,
               }),
            );

            toast({
               title: 'OTP Sent',
               description: 'Please check your email for the verification code',
               status: 'success',
               duration: 3000,
               isClosable: true,
            });

            // Reset OTP values and show modal
            setOtpValue(['', '', '', '', '', '']);
            setShowOtpModal(true);
         } catch (error) {
            toast({
               title: 'Error',
               description: 'Failed to send OTP. Please try again.',
               status: 'error',
               duration: 3000,
               isClosable: true,
            });
         } finally {
            setOtpLoading(false);
         }
      } else {
         // For other fields, update directly
         try {
            await dispatch(updateUser({ id: user?.id, [fieldName.toLowerCase()]: value }));
            await dispatch(userProfile());
            setIsEditing(false);
         } catch (error) {
            console.error('Update failed:', error);
         }
      }
   };
   const handleNameUpdate = async (value) => {
      try {
         setIsEditingName(false);

         await dispatch(
            updateUser({
               id: user?.id,
               name: editedName,
            }),
         );

         await dispatch(userProfile());
         setIsEditingMobile(false);

         // toast({
         //    title: 'Success',
         //    description: `${fieldName} updated successfully`,
         //    status: 'success',
         //    duration: 3000,
         //    isClosable: true,
         // });

         setPendingUpdate(null);
      } catch (error) {
         console.error('Update failed:', error);
         toast({
            title: 'Error',
            description: error.response?.data?.message || 'Update failed. Please verify your OTP and try again.',
            status: 'error',
            duration: 3000,
            isClosable: true,
         });
      } finally {
         setOtpLoading(false);
      }
   };

   const handleVerifyOtpAndUpdate = async () => {
      const otpString = otpValue.join('');

      if (!otpString.trim()) {
         toast({
            title: 'Error',
            description: 'Please enter the OTP',
            status: 'error',
            duration: 3000,
            isClosable: true,
         });
         return;
      }

      if (otpString.length !== 6) {
         toast({
            title: 'Error',
            description: 'Please enter a valid 6-digit OTP',
            status: 'error',
            duration: 3000,
            isClosable: true,
         });
         return;
      }

      if (!pendingUpdate) return;

      try {
         setOtpLoading(true);

         // Convert OTP string to number
         const otpNumber = parseInt(otpString, 10);

         // Proceed with update
         const { id, fieldConfig } = pendingUpdate;
         const { value, fieldName, setIsEditing } = fieldConfig;

         // Include OTP as number in the update request
         await dispatch(
            updateUser({
               id: user?.id,
               [fieldName.toLowerCase()]: value,
               otp: otpNumber, // Pass as number instead of string
            }),
         );

         await dispatch(userProfile());
         setIsEditing(false);

         toast({
            title: 'Success',
            description: `${fieldName} updated successfully`,
            status: 'success',
            duration: 3000,
            isClosable: true,
         });

         // Reset states
         setShowOtpModal(false);
         setOtpValue(['', '', '', '', '', '']);
         setPendingUpdate(null);
      } catch (error) {
         console.error('Update failed:', error);
         toast({
            title: 'Error',
            description: error.response?.data?.message || 'Update failed. Please verify your OTP and try again.',
            status: 'error',
            duration: 3000,
            isClosable: true,
         });
      } finally {
         setOtpLoading(false);
      }
   };

   // Function to cancel OTP verification
   const handleCancelOtpVerification = () => {
      setShowOtpModal(false);
      setOtpValue(['', '', '', '', '', '']);
      setPendingUpdate(null);

      // Reset editing states if needed
      if (pendingUpdate?.fieldConfig?.fieldName === 'name') {
         setIsEditingName(false);
         setEditedName(user?.name || '');
      } else if (pendingUpdate?.fieldConfig?.fieldName === 'mobile') {
         setIsEditingMobile(false);
         setEditedMobile(user?.mobile || '');
      }
   };

   // Handle OTP input change
   const handleOtpChange = (index, value) => {
      if (value.length > 1) return; // Only allow single character
      if (value && !/^\d$/.test(value)) return; // Only allow digits

      const newOtpValue = [...otpValue];
      newOtpValue[index] = value;
      setOtpValue(newOtpValue);

      // Auto-focus next input
      if (value && index < 5) {
         otpRefs.current[index + 1]?.focus();
      }
   };

   // Handle OTP backspace
   const handleOtpKeyDown = (index, e) => {
      if (e.key === 'Backspace' && !otpValue[index] && index > 0) {
         otpRefs.current[index - 1]?.focus();
      }
   };

   const handleCancelEditMobile = () => {
      setEditedMobile('');
      setIsEditingMobile(false);
   };

   // Skeleton Components
   const FinancialYearSkeleton = () => (
      <Skeleton
         width={{ base: '100px', md: '200px', lg: '250px' }}
         height="35px"
         borderRadius="8px"
         className={isDark ? 'bg-gray-700' : 'bg-gray-200'}
      />
   );

   const UserAvatarSkeleton = () => (
      <Flex align="center" gap={2}>
         <SkeletonCircle size="8" className={isDark ? 'bg-gray-700' : 'bg-gray-200'} />
      </Flex>
   );

   const HelpButtonSkeleton = () => (
      <Skeleton width="120px" height="40px" borderRadius="12px" className={isDark ? 'bg-gray-700' : 'bg-gray-200'} />
   );

   const ProfileModalSkeleton = () => (
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
         <div className={`absolute inset-0 backdrop-blur-sm ${isDark ? 'bg-black/70' : 'bg-black/60'}`}></div>
         <div
            className={`relative rounded-2xl shadow-2xl w-full max-w-md mx-auto max-h-[90vh] overflow-hidden border ${isDark ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-100'
               }`}>
            {/* Header Skeleton */}
            <div
               className={`px-8 py-6 border-b ${isDark ? 'bg-gray-700 border-gray-600' : 'bg-gray-100 border-gray-200'
                  }`}>
               <Skeleton height="28px" width="60%" className={isDark ? 'bg-gray-600' : 'bg-gray-300'} />
               <Skeleton height="16px" width="40%" mt={2} className={isDark ? 'bg-gray-600' : 'bg-gray-300'} />
            </div>

            {/* Body Skeleton */}
            <div className="px-8 py-6 space-y-6">
               {/* Avatar Section */}
               <div className="text-center">
                  <SkeletonCircle size="20" className="mx-auto mb-4" />
                  <Skeleton height="24px" width="70%" className="mx-auto" />
               </div>

               {/* Fields */}
               <div className="space-y-4">
                  <Skeleton height="20px" width="30%" />
                  <Skeleton height="40px" width="100%" />

                  <Skeleton height="20px" width="30%" />
                  <Skeleton height="40px" width="100%" />

                  <Skeleton height="20px" width="30%" />
                  <Skeleton height="40px" width="100%" />
               </div>

               {/* 2FA Section */}
               <Skeleton height="60px" width="100%" />

               {/* Change Password Button */}
               <Skeleton height="44px" width="100%" borderRadius="12px" />
            </div>
         </div>
      </div>
   );
   const [loader, setLoader] = useState(true);
   const [show, setShow] = useState(false);

   useEffect(() => {
      if (user) {
         if (user.isExpired) {
            setShow(true);
            setLoader(false);
         } else {
            setShow(false);
            setLoader(false);
         }
      }
   }, [user]);

   const isExpired = user?.isExpired;

   return (
      <>
         <PackageExpiredModal loader={loader} isOpen={show} onClose={() => setShow(false)} />
         {/* Expiring Soon Warning */}
         {shouldShowExpiryWarning && !isExpired && (
            <div className="fixed right-6 bottom-6 z-40 pointer-events-none select-none">
               <h3
                  className={`font-light text-[32px] opacity-50 leading-tight mb-1 ${isDark ? 'text-gray-400/60' : 'text-gray-500/50'
                     }`}>
                  Package Expiring Soon
               </h3>
               <p className={`font-light text-[20px] opacity-50 ${isDark ? 'text-gray-500/60' : 'text-gray-600/50'}`}>
                  Your package will expire in {activeUserPackage?.expireInDays}{' '}
                  {activeUserPackage?.expireInDays === 1 ? 'day' : 'days'}.
               </p>
            </div>
         )}

         {/* Expired Message */}
         {isExpired && (
            <div
               className={`fixed -right-1 bottom-1 rounded-lg shadow-xl z-40 flex opacity-75 items-start gap-3 px-4 py-2 max-w-sm border-l-4 border-red-500 pointer-events-none select-none ${isDark
                  ? 'bg-gray-800 border-r border-t border-b border-gray-700'
                  : 'bg-red-50 border-r border-t border-b border-red-100'
                  }`}>
               <div className="flex-shrink-0">
                  <div
                     className={`w-10 h-10 rounded-full flex items-center justify-center ${isDark ? 'bg-red-500/20' : 'bg-red-500/10'
                        }`}>
                     <svg className="w-6 h-6 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path
                           strokeLinecap="round"
                           strokeLinejoin="round"
                           strokeWidth={2}
                           d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                     </svg>
                  </div>
               </div>

               <div className="flex-1">
                  <h3 className={`font-semibold text-base ${isDark ? 'text-white' : 'text-gray-900'}`}>
                     Package Expired
                  </h3>
                  <p className={`text-sm leading-relaxed ${isDark ? 'text-gray-300' : 'text-gray-600'}`}>
                     Your package has expired. Please renew to continue using all features.
                  </p>
               </div>
            </div>
         )}

         <Flex
            alignItems="center"
            justifyContent="space-between"
            className={`shadow-2xl shadow-green-400/10 z-50 ${isDark ? 'bg-[#16213E]' : 'bg-white'}`}
            px={'10px'}
            role="group"
            flexWrap="wrap"
            flexDirection="row"
            zIndex={1}
            gap={{ base: 2, md: 3 }}
            position="relative"
            transitionDelay="fast">
            <Flex>
               {/* Sidebar Section */}
               {!isMobile && (
                  <div className={`sidebar-wrapper ${props.isSidebarOpen ? 'open' : 'closed'}`}>
                     <div className="toggle-button">
                        <Tooltip
                           label={props.isSidebarOpen ? 'Open Sidebar' : 'Close Sidebar'}
                           hasArrow
                           placement="right">
                           <span>
                              {props.isSidebarOpen ? (
                                 <AiOutlineMenuUnfold
                                    size={25}
                                    cursor={'pointer'}
                                    onClick={toggleSidebars}
                                    className={`${isDark ? 'text-white' : 'text-gray-800'}`}
                                 />
                              ) : (
                                 <AiOutlineMenuFold
                                    size={25}
                                    cursor={'pointer'}
                                    onClick={toggleSidebars}
                                    className={`${isDark ? 'text-white' : 'text-gray-800'}`}
                                 />
                              )}
                           </span>
                        </Tooltip>
                     </div>
                     <div className="sidebar-content">
                        <div className={`full-sidebar ${props.isSidebarOpen ? 'visible' : 'hidden'}`}>
                           <IconSidebar routes={filterRoutesData} />
                        </div>
                        <div className={`icon-sidebar ${props.isSidebarOpen ? 'hidden' : 'visible'}`}>
                           <Sidebar routes={filterRoutesData} />
                        </div>
                     </div>
                  </div>
               )}

               <style>{`
    .sidebar-wrapper {
      position: relative;
      overflow: hidden;
      transition: width 0.3s ease-in-out;
      height: 100%;
    }
    
    .sidebar-wrapper.open {
      width: 250px;
    }
    
    .sidebar-wrapper.closed {
      width: 60px;
    }
    
    .toggle-button {
      padding: 10px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
    }
    
    .sidebar-content {
      position: relative;
      width: 100%;
    }
    
    .full-sidebar, .icon-sidebar {
      transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
    }
    
    .visible {
      opacity: 1;
      visibility: visible;
    }
    
    .hidden {
      opacity: 0;
      visibility: hidden;
      pointer-events: none;
    }
  `}</style>

               <SidebarResponsive routes={filterRoutesData} />
            </Flex>

            {/* Right Side Controls */}
            <Flex alignItems="center" justifyContent="end" gap={2} className="flex-wrap">
               {shouldShowExpiryWarning && !isExpired && (
                  <button
                     onClick={() => setShowUpgrade(true)}
                     className={`px-4 py-2 font-semibold rounded-lg transition-all duration-200 
    flex items-center gap-2.5 border-2 hover:shadow-md ${isDark
                           ? 'border-green-500 text-green-400 hover:bg-green-500/10 hover:border-green-400'
                           : 'border-green-600 text-green-600 hover:bg-green-50 hover:border-green-700'
                        }`}>
                     <Clock className="w-4 h-4" />
                     Renew Now
                  </button>
               )}
               <Flex justifyContent="center" alignItems="center" gap={2}>
                  {/* Search Bar */}
                  <Box pt={1} zIndex={''}>
                     <SearchBarGlobal
                        w={{
                           base: '220px',
                           md: '220px',
                           lg: '220px',
                        }}
                        borderRadius="30px"
                     />
                  </Box>
                  {/* Financial Year Dropdown */}
                  <Flex>
                     {isFinancialYearsLoading ? (
                        <FinancialYearSkeleton />
                     ) : (
                        <>
                           <Select
                              borderRadius={'30px'}
                              className={`border ${isDark
                                 ? 'border-gray-600 bg-gray-800 text-white hover:bg-gray-700'
                                 : 'border-gray-300 bg-white text-gray-900 hover:bg-gray-50'
                                 } rounded-lg transition-colors duration-200`}
                              placeholder="Select financial year"
                              selectedValue={selectedFinancialYear}
                              onChange={(e) => handleFinancialYearChange(e.target.value)}>
                              {option?.map((option) => (
                                 <option
                                    key={option}
                                    value={option.financial_year}
                                    selected={option.financial_year === selectedFinancialYear}>
                                    {option.financial_year}
                                 </option>
                              ))}
                           </Select>
                        </>
                     )}
                  </Flex>
                  {/* Help Dropdown */}
                  <Box>
                     {isUserLoading ? (
                        <HelpButtonSkeleton />
                     ) : (
                        <Menu isOpen={isMenuOpen} onClose={() => setIsMenuOpen(false)}>
                           <MenuButton
                              className={`border ${isDark
                                 ? 'border-gray-600 bg-gradient-to-r from-gray-700 to-gray-800 hover:from-gray-600 hover:to-gray-700 shadow-lg'
                                 : 'border-gray-300 bg-gradient-to-r from-white to-gray-50 hover:from-gray-50 hover:to-gray-100 shadow-md'
                                 } rounded-xl px-4 py-1 transition-all duration-200 hover:shadow-xl group`}
                              onClick={() => setIsMenuOpen(!isMenuOpen)}>
                              <Flex
                                 justifyContent="space-between"
                                 alignItems="center"
                                 gap={3}
                                 className={isDark ? 'text-white' : 'text-gray-800'}>
                                 <Flex alignItems="center" gap={2}>
                                    <Box
                                       className={`w-7 h-7 rounded-lg flex items-center justify-center ${isDark ? 'bg-blue-500/20' : 'bg-blue-100'
                                          } group-hover:scale-110 transition-transform duration-200`}>
                                       <svg
                                          className="w-4 h-4 text-blue-500"
                                          fill="none"
                                          stroke="currentColor"
                                          viewBox="0 0 24 24">
                                          <path
                                             strokeLinecap="round"
                                             strokeLinejoin="round"
                                             strokeWidth={2}
                                             d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192l-3.536 3.536M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-5 0a4 4 0 11-8 0 4 4 0 018 0z"
                                          />
                                       </svg>
                                    </Box>
                                    <Text fontSize="13px" fontWeight="600">
                                       help?
                                    </Text>
                                 </Flex>
                                 <Box
                                    className="transition-transform duration-200"
                                    style={{ transform: isMenuOpen ? 'rotate(180deg)' : 'rotate(0deg)' }}>
                                    <FaCaretDown className="text-gray-400" />
                                 </Box>
                              </Flex>
                           </MenuButton>

                           <MenuList
                              minW="260px"
                              py={0}
                              className={`${isDark
                                 ? 'bg-gradient-to-br from-gray-800 to-gray-900 border-gray-700'
                                 : 'bg-white border-gray-200'
                                 } shadow-2xl rounded-xl overflow-hidden`}>
                              {/* Header */}
                              <Box
                                 className={`${isDark
                                    ? 'bg-gradient-to-r from-blue-600/20 to-purple-600/20'
                                    : 'bg-gradient-to-r from-blue-50 to-indigo-50'
                                    } px-4 py-3 border-b ${isDark ? 'border-gray-700' : 'border-gray-200'}`}>
                                 <Text
                                    fontSize="14px"
                                    fontWeight="bold"
                                    className={isDark ? 'text-white' : 'text-gray-800'}>
                                    How can we help you?
                                 </Text>
                                 <Text fontSize="11px" className={isDark ? 'text-gray-400' : 'text-gray-600'}>
                                    Choose your preferred contact method
                                 </Text>
                              </Box>

                              {/* Contact Methods */}
                              <Box className="py-2">
                                 <MenuItem
                                    gap={3}
                                    fontSize="13px"
                                    fontWeight="600"
                                    className={`${isDark ? 'hover:bg-gray-700/50 text-white' : 'hover:bg-green-50 text-gray-800'
                                       } transition-all duration-200 mx-2 rounded-lg px-3 py-3 group`}>
                                    <Box
                                       className={`w-9 h-9 rounded-lg flex items-center justify-center ${isDark
                                          ? 'bg-green-500/20 group-hover:bg-green-500/30'
                                          : 'bg-green-100 group-hover:bg-green-200'
                                          } transition-colors duration-200`}>
                                       <IoLogoWhatsapp size={20} className="text-green-500" />
                                    </Box>
                                    <Flex direction="column" gap={0.5}>
                                       <Text fontSize="13px" fontWeight="600">
                                          WhatsApp
                                       </Text>
                                       <Text fontSize="11px" className={isDark ? 'text-gray-400' : 'text-gray-500'}>
                                          Chat on WhatsApp
                                       </Text>
                                    </Flex>
                                 </MenuItem>

                                 <MenuItem
                                    gap={3}
                                    fontSize="13px"
                                    fontWeight="600"
                                    className={`${isDark ? 'hover:bg-gray-700/50 text-white' : 'hover:bg-blue-50 text-gray-800'
                                       } transition-all duration-200 mx-2 rounded-lg px-3 py-3 group`}>
                                    <Box
                                       className={`w-9 h-9 rounded-lg flex items-center justify-center ${isDark
                                          ? 'bg-blue-500/20 group-hover:bg-blue-500/30'
                                          : 'bg-blue-100 group-hover:bg-blue-200'
                                          } transition-colors duration-200`}>
                                       <IoLogoWechat size={20} className="text-blue-500" />
                                    </Box>
                                    <Flex direction="column" gap={0.5}>
                                       <Text fontSize="13px" fontWeight="600">
                                          Live Chat
                                       </Text>
                                       <Text fontSize="11px" className={isDark ? 'text-gray-400' : 'text-gray-500'}>
                                          Instant messaging
                                       </Text>
                                    </Flex>
                                 </MenuItem>
                              </Box>

                              {/* Support Section */}
                              <Box className={`mt-2 border-t ${isDark ? 'border-gray-700' : 'border-gray-200'}`}>
                                 <Box className="px-4 py-2">
                                    <Text
                                       fontSize="12px"
                                       fontWeight="700"
                                       textTransform="uppercase"
                                       letterSpacing="wider"
                                       className={isDark ? 'text-gray-400' : 'text-gray-500'}>
                                       Support
                                    </Text>
                                 </Box>

                                 <MenuItem
                                    gap={3}
                                    fontSize="13px"
                                    fontWeight="600"
                                    className={`${isDark ? 'hover:bg-gray-700/50 text-white' : 'hover:bg-purple-50 text-gray-800'
                                       } transition-all duration-200 mx-2 mb-2 rounded-lg px-3 py-3 group`}>
                                    <Box
                                       className={`w-9 h-9 rounded-lg flex items-center justify-center ${isDark
                                          ? 'bg-purple-500/20 group-hover:bg-purple-500/30'
                                          : 'bg-purple-100 group-hover:bg-purple-200'
                                          } transition-colors duration-200`}>
                                       <BiSupport size={20} className="text-purple-500" />
                                    </Box>
                                    <Flex direction="column" gap={0.5}>
                                       <Text fontSize="13px" fontWeight="600">
                                          Call Support
                                       </Text>
                                       <Text fontSize="12px" fontWeight="700" className="text-purple-500">
                                          0123456789
                                       </Text>
                                    </Flex>
                                 </MenuItem>
                              </Box>
                           </MenuList>
                        </Menu>
                     )}
                  </Box>
                  <div className="flex items-center gap-0">
                     <Tooltip label="Refresh Masters" placement="bottom">
                        <Box className="relative">
                           <button
                              onClick={handleMastersRefresh}
                              disabled={isRefreshing}
                              className={`flex items-center justify-center p-2 rounded-full transition-all duration-200 ${isDark ? 'hover:bg-gray-700 text-white' : 'hover:bg-gray-100 text-gray-700'
                                 } ${isRefreshing ? 'opacity-70 cursor-not-allowed' : ''}`}>
                              {isRefreshing ? <Spinner size="sm" /> : <HiOutlineRefresh size={23} />}
                           </button>
                        </Box>
                     </Tooltip>
                     {/* Chat Icon */}
                     {(isAdmin || userRights?.chat?.view) && (
                        <Tooltip label="Chats" placement="bottom">
                           <Box className="relative">
                              <button
                                 onClick={() => navigate('/admin/chats')}
                                 className={`flex items-center justify-center p-2 rounded-full transition-all duration-200 ${isDark ? 'hover:bg-gray-700' : 'hover:bg-gray-100'
                                    }`}
                                 aria-label="Open Chats"
                              >
                                 <IoLogoWechat size={25} color="#25D366" />
                              </button>
                           </Box>
                        </Tooltip>
                     )}

                     {/* Notification Icon with Badge */}
                     <Tooltip label="Notification" placement="bottom">
                        <Box className="relative">
                           <button
                              onClick={handleOpenNotification}
                              className={`flex items-center justify-center p-2 rounded-full transition-all duration-200 ${isDark ? 'hover:bg-gray-700 text-white' : 'hover:bg-gray-100 text-gray-700'
                                 }`}>
                              <IoIosSend size={23} />
                              {Paginationdata?.unReadCount > 0 && (
                                 <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center">
                                    {Paginationdata.unReadCount > 99 ? '99+' : Paginationdata.unReadCount}
                                 </span>
                              )}
                           </button>
                        </Box>
                     </Tooltip>

                     {/* Notify Icon */}
                     <Tooltip label="Notify Me" placement="bottom">
                        <Box className="relative">
                           <button
                              ref={buttonRef}
                              onClick={handleOpenNotify}
                              className={`flex items-center justify-center p-2 rounded-full transition-all duration-200 ${isDark ? 'hover:bg-gray-700 text-white' : 'hover:bg-gray-100 text-gray-700'
                                 }`}
                              aria-label="Open Notify Me form">
                              <MdNotificationsActive size={25} />
                           </button>
                        </Box>
                     </Tooltip>
                     {/* Feedback Icon */}
                     <Tooltip label="Feedback" placement="bottom">
                        <Box className="relative">
                           <button
                              ref={buttonRef}
                              onClick={handleOpenModal}
                              className={`flex items-center justify-center p-2 rounded-full transition-all duration-200 ${isDark ? 'hover:bg-gray-700 text-white' : 'hover:bg-gray-100 text-gray-700'
                                 }`}
                              aria-label="Open feedback form">
                              <MdFeedback size={25} />
                           </button>
                        </Box>
                     </Tooltip>

                     {/* Backup Button (Admin Only) */}
                     {isAdmin && (
                        <Tooltip label="Backup" placement="bottom">
                           <Box className="relative">
                              <button
                                 ref={buttonRef}
                                 onClick={handleBackup}
                                 className={`flex items-center justify-center p-2 rounded-full transition-all duration-200 ${isDark ? 'hover:bg-gray-700 text-white' : 'hover:bg-gray-100 text-gray-700'
                                    }`}
                                 aria-label="Open Backup form">
                                 <MdBackup size={25} />
                              </button>
                           </Box>
                        </Tooltip>
                     )}
                     {/* Network Status Icon */}
                     <Tooltip label="Network Status" placement="bottom">
                        <Box className="relative">
                           <button
                              className={`flex items-center justify-center p-2 rounded-full transition-all duration-200 ${isDark ? 'hover:bg-gray-700' : 'hover:bg-gray-100'
                                 }`}
                              aria-label="Network status">
                              <GiNetworkBars
                                 size={21}
                                 className={`transition-colors duration-200 ${!isOnline
                                    ? 'text-red-500'
                                    : networkSpeed === 'good'
                                       ? 'text-green-500'
                                       : networkSpeed === 'medium'
                                          ? 'text-yellow-500'
                                          : 'text-orange-500'
                                    }`}
                              />
                              {!isOnline && (
                                 <span className="absolute top-0 right-0 w-2 h-2 bg-red-500 rounded-full animate-pulse"></span>
                              )}
                           </button>
                        </Box>
                     </Tooltip>
                     {/* Keyboard Shortcuts Icon */}
                     <Tooltip label="Keyboard Shortcuts" placement="bottom">
                        <Box>
                           <div
                              onClick={onOpen}
                              className={`flex items-center justify-center p-2 rounded-full cursor-pointer transition-all duration-200 ${isDark ? 'hover:bg-gray-700 text-white' : 'hover:bg-gray-100 text-gray-700'
                                 }`}>
                              <FaRegKeyboard size={25} />
                           </div>
                        </Box>
                     </Tooltip>
                     {/* Theme Toggle Icon */}
                     <Tooltip label="Theme" placement="bottom">
                        <Box>
                           <button
                              onClick={toggleColorMode}
                              className={`flex items-center justify-center p-2 rounded-full transition-all duration-200 ${isDark ? 'hover:bg-gray-700' : 'hover:bg-gray-100'
                                 }`}>
                              <Icon
                                 h="22px"
                                 w="22px"
                                 className={`transition-colors duration-200 ${isDark ? 'text-yellow-400' : 'text-gray-700'
                                    }`}
                                 as={colorMode === 'light' ? IoMdMoon : IoMdSunny}
                              />
                           </button>
                        </Box>
                     </Tooltip>
                  </div>
                  {/* Network Status Banners */}
                  {!isOnline && (
                     <div
                        className={`fixed top-0 left-0 right-0 z-50 flex items-center justify-center gap-3 px-4 py-3 shadow-lg ${isDark ? 'bg-red-900/95 backdrop-blur-sm' : 'bg-red-500'
                           }`}>
                        <GiNetworkBars size={20} className="text-white animate-pulse" />
                        <Text className="text-white font-semibold">
                           No Internet Connection - Please check your network
                        </Text>
                     </div>
                  )}
                  {isOnline && networkSpeed === 'slow' && (
                     <div
                        className={`fixed top-0 left-0 right-0 z-50 flex items-center justify-center gap-3 px-4 py-2 shadow-md ${isDark ? 'bg-orange-900/95 backdrop-blur-sm' : 'bg-orange-500'
                           }`}>
                        <GiNetworkBars size={18} className="text-white" />
                        <Text className="text-white text-sm font-medium">Slow Connection Detected</Text>
                     </div>
                  )}
                  {/* Keyboard Shortcuts Drawer */}
                  <Drawer
                     isOpen={isOpen}
                     placement="right"
                     onClose={onClose}
                     size="md"
                     closeOnOverlayClick={true}
                     initialFocusRef={buttonRef}>
                     <DrawerOverlay />
                     <DrawerContent className={`${isDark ? 'bg-gray-800 text-white' : 'bg-white text-gray-800'}`}>
                        <DrawerHeader
                           borderBottomWidth="1px"
                           className={isDark ? 'border-gray-700' : 'border-gray-200'}>
                           <Flex alignItems="center" width="100%" gap={4}>
                              <MdOutlineKeyboardArrowRight
                                 size={25}
                                 onClick={onClose}
                                 className="cursor-pointer transition-colors duration-200 hover:text-blue-400"
                              />
                              <Text className={isDark ? 'text-white' : 'text-gray-800'}>Keyboard Shortcuts</Text>
                           </Flex>
                        </DrawerHeader>
                        <DrawerBody>
                           <Table variant="simple">
                              <Tbody>
                                 {filteredShortcuts.map((item, index) => (
                                    <Tr key={index}>
                                       <Td
                                          p={3}
                                          borderBottom="1px"
                                          className={
                                             isDark ? 'border-gray-700 text-white' : 'border-gray-200 text-gray-800'
                                          }>
                                          {item.name}
                                       </Td>
                                       <Td
                                          p={3}
                                          borderBottom="1px"
                                          className={isDark ? 'border-gray-700' : 'border-gray-200'}>
                                          <span
                                             className={`inline-flex items-center px-3 py-1.5 rounded-md ${isDark ? 'bg-gray-700 text-gray-200' : 'bg-gray-200 text-gray-800'
                                                } text-sm font-medium`}>
                                             {item.shortcut}
                                             {item.name === 'Global Search' && (
                                                <MdOutlineSpaceBar size={23} className="ml-1" />
                                             )}
                                          </span>
                                       </Td>
                                    </Tr>
                                 ))}
                              </Tbody>
                           </Table>
                        </DrawerBody>
                     </DrawerContent>
                  </Drawer>
                  {/* User Profile Dropdown */}
                  <Box>
                     {isUserLoading ? (
                        <UserAvatarSkeleton />
                     ) : (
                        <Menu>
                           <MenuButton
                              as={Button}
                              variant="ghost"
                              p={1}
                              className="hover:bg-transparent focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 rounded-full transition-all duration-200">
                              <Flex align="center">
                                 <Avatar
                                    size="sm"
                                    name={user?.name || ''}
                                    className="ring-2 ring-blue-500/20 hover:ring-blue-500/40 transition-all duration-200"
                                 />
                              </Flex>
                           </MenuButton>

                           <MenuList
                              minWidth="280px"
                              py={0}
                              className={`${isDark
                                 ? 'bg-gradient-to-br from-gray-800 to-gray-900 border-gray-700'
                                 : 'bg-white border-gray-200'
                                 } shadow-2xl rounded-xl overflow-hidden backdrop-blur-sm`}>
                              {/* Header Section with Gradient Background */}
                              <Box
                                 className={`${isDark
                                    ? 'bg-gradient-to-r from-blue-600/20 to-purple-600/20'
                                    : 'bg-gradient-to-r from-blue-50 to-indigo-50'
                                    } px-6 py-5`}>
                                 <Flex direction="column" align="center">
                                    <Box className="relative mb-3">
                                       <Avatar
                                          size="lg"
                                          name={user?.name || ''}
                                          className="ring-4 ring-white/50 shadow-lg"
                                       />
                                       <Box
                                          className={`absolute -bottom-1 -right-1 w-4 h-4 rounded-full border-2 ${isDark ? 'bg-green-500 border-gray-800' : 'bg-green-500 border-white'
                                             }`}
                                       />
                                    </Box>

                                    <Text
                                       fontWeight="bold"
                                       fontSize="lg"
                                       textAlign="center"
                                       className={`${isDark ? 'text-white' : 'text-gray-900'} mb-1`}>
                                       {user?.name || ''}
                                    </Text>

                                    <Text
                                       fontSize="sm"
                                       textAlign="center"
                                       className={`${isDark ? 'text-gray-300' : 'text-gray-600'
                                          } flex items-center gap-1`}>
                                       <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                                          <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                                          <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                                       </svg>
                                       {user?.email || ''}
                                    </Text>

                                    <Text
                                       fontSize="sm"
                                       textAlign="center"
                                       className={`${isDark ? 'text-gray-300' : 'text-gray-600'
                                          } flex items-center gap-1 mt-1`}>
                                       <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                                          <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                                       </svg>
                                       {user?.mobile || ''}
                                    </Text>
                                 </Flex>
                              </Box>

                              {/* Menu Items */}
                              <Box className="py-2">
                                 <MenuItem
                                    onClick={() => setIsOpenProfile(true)}
                                    className={`${isDark ? 'hover:bg-gray-700/50 text-white' : 'hover:bg-blue-50 text-gray-800'
                                       } transition-all duration-200 mx-2 rounded-lg px-4 py-3 flex items-center gap-3 group`}>
                                    <Box
                                       className={`w-9 h-9 rounded-lg flex items-center justify-center ${isDark
                                          ? 'bg-blue-500/20 group-hover:bg-blue-500/30'
                                          : 'bg-blue-100 group-hover:bg-blue-200'
                                          } transition-colors duration-200`}>
                                       <svg
                                          className="w-5 h-5 text-blue-500"
                                          fill="none"
                                          stroke="currentColor"
                                          viewBox="0 0 24 24">
                                          <path
                                             strokeLinecap="round"
                                             strokeLinejoin="round"
                                             strokeWidth={2}
                                             d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                                          />
                                       </svg>
                                    </Box>
                                    <Text fontWeight="medium">My Profile</Text>
                                 </MenuItem>

                                 <MenuDivider className={`${isDark ? 'border-gray-700' : 'border-gray-200'} my-2`} />

                                 <MenuItem
                                    onClick={handleLogout}
                                    className="text-red-600 hover:bg-red-50 dark:hover:bg-red-500/10 transition-all duration-200 mx-2 rounded-lg px-4 py-3 flex items-center gap-3 group mb-2">
                                    <Box className="w-9 h-9 rounded-lg flex items-center justify-center bg-red-100 group-hover:bg-red-200 dark:bg-red-500/20 dark:group-hover:bg-red-500/30 transition-colors duration-200">
                                       <svg
                                          className="w-5 h-5 text-red-600"
                                          fill="none"
                                          stroke="currentColor"
                                          viewBox="0 0 24 24">
                                          <path
                                             strokeLinecap="round"
                                             strokeLinejoin="round"
                                             strokeWidth={2}
                                             d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                                          />
                                       </svg>
                                    </Box>
                                    <Text fontWeight="medium">Log Out</Text>
                                 </MenuItem>
                              </Box>
                           </MenuList>
                        </Menu>
                     )}

                     {/* Profile Modal */}
                     {isOpenProfile &&
                        (isUserLoading ? (
                           <ProfileModalSkeleton />
                        ) : (
                           <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
                              {/* Backdrop */}
                              <div
                                 className={`absolute inset-0 backdrop-blur-sm transition-all duration-300 ${isDark ? 'bg-black/70' : 'bg-black/60'
                                    }`}
                                 onClick={() => setIsOpenProfile(false)}></div>

                              {/* Modal Content */}
                              <div
                                 className={`relative rounded-2xl shadow-2xl w-full max-w-md mx-auto max-h-[90vh] overflow-hidden border flex flex-col transition-all duration-300 ${isDark ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-100'
                                    }`}>
                                 {/* Modal Header - Fixed */}
                                 <div
                                    className={`flex-shrink-0 relative px-8 py-3 border-b ${isDark
                                       ? 'bg-gradient-to-r from-gray-700 to-gray-800 border-gray-700'
                                       : 'bg-gradient-to-r from-[#c5f5c8] to-[#b8f0bb] border-[#c5f5c8]/20'
                                       }`}>
                                    <div className="flex items-start justify-between">
                                       <div>
                                          <h2
                                             className={`text-2xl font-bold ${isDark ? 'text-white' : 'text-gray-800'
                                                }`}>
                                             My Profile
                                          </h2>
                                          <p
                                             className={`text-sm font-medium ${isDark ? 'text-gray-300' : 'text-gray-600'
                                                }`}>
                                             Basic Information
                                          </p>
                                       </div>
                                       <button
                                          onClick={() => setIsOpenProfile(false)}
                                          className={`ml-4 p-2 rounded-full transition-all duration-200 group ${isDark
                                             ? 'text-gray-400 hover:text-gray-200 hover:bg-gray-700'
                                             : 'text-gray-500 hover:text-gray-700 hover:bg-white/50'
                                             }`}>
                                          <svg
                                             className="w-5 h-5 group-hover:scale-110 transition-transform"
                                             fill="none"
                                             stroke="currentColor"
                                             viewBox="0 0 24 24">
                                             <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth={2}
                                                d="M6 18L18 6M6 6l12 12"
                                             />
                                          </svg>
                                       </button>
                                    </div>
                                    {/* Decorative element */}
                                    <div
                                       className={`absolute bottom-0 left-8 right-8 h-0.5 ${isDark
                                          ? 'bg-gradient-to-r from-gray-600 via-gray-500 to-gray-600'
                                          : 'bg-gradient-to-r from-[#c5f5c8] via-[#a8e6ac] to-[#c5f5c8]'
                                          }`}></div>
                                 </div>

                                 {/* Modal Body - Scrollable */}
                                 <div
                                    className={`flex-1 overflow-y-auto px-8 py-6 space-y-6 scrollbar-thin ${isDark
                                       ? 'bg-gray-900/30 scrollbar-thumb-gray-600 scrollbar-track-gray-800'
                                       : 'bg-gray-50/30 scrollbar-thumb-[#c5f5c8] scrollbar-track-gray-100'
                                       }`}>
                                    {/* Avatar Section */}
                                    <div className="text-center relative">
                                       {/* Avatar */}
                                       <div className="relative inline-block mb-4">
                                          <div
                                             className={`w-20 h-20 rounded-full flex items-center justify-center text-2xl font-bold shadow-lg ring-4 ${isDark
                                                ? 'bg-gradient-to-br from-gray-600 to-gray-700 text-gray-300 ring-gray-800'
                                                : 'bg-gradient-to-br from-[#c5f5c8] to-[#a8e6ac] text-gray-700 ring-white'
                                                }`}>
                                             {user?.name ? user.name.charAt(0).toUpperCase() : 'U'}
                                          </div>
                                          {/* Online indicator */}
                                          <div className="absolute bottom-1 right-1 w-5 h-5 bg-green-400 rounded-full border-2 border-white shadow-sm"></div>
                                       </div>

                                       {/* Name Section */}
                                       {isEditingName ? (
                                          <div className="flex items-center justify-center space-x-3">
                                             <input
                                                value={editedName}
                                                onChange={(e) => setEditedName(e.target.value)}
                                                className={`text-lg font-bold text-center backdrop-blur-sm border-2 rounded-xl px-4 py-2 max-w-[200px] focus:outline-none focus:ring-4 transition-all duration-200 ${isDark
                                                   ? 'bg-gray-700 border-gray-600 text-white focus:ring-gray-500'
                                                   : 'bg-white/80 border-[#c5f5c8] focus:ring-[#c5f5c8]/20'
                                                   }`}
                                                maxLength={50}
                                             />
                                             <button
                                                onClick={() => handleNameUpdate()}
                                                className={`p-2 rounded-xl focus:outline-none focus:ring-4 transition-all duration-200 transform hover:scale-110 ${isDark
                                                   ? 'text-white bg-gradient-to-r from-gray-600 to-gray-700 hover:from-gray-500 hover:to-gray-600 focus:ring-gray-500'
                                                   : 'text-white bg-gradient-to-r from-[#a8e6ac] to-[#c5f5c8] hover:from-[#95d99a] hover:to-[#b8f0bb] focus:ring-[#c5f5c8]/30'
                                                   }`}
                                                aria-label="Save name">
                                                <FaCheck className="w-4 h-4" />
                                             </button>
                                             <button
                                                onClick={() => handleCancelEditName()}
                                                className={`p-2 rounded-xl focus:outline-none focus:ring-4 transition-all duration-200 transform hover:scale-110 ${isDark
                                                   ? 'text-gray-400 hover:text-gray-200 hover:bg-gray-700 focus:ring-gray-600'
                                                   : 'text-gray-500 hover:text-gray-700 hover:bg-gray-100 focus:ring-gray-200'
                                                   }`}
                                                aria-label="Cancel edit">
                                                <svg
                                                   className="w-4 h-4"
                                                   fill="none"
                                                   stroke="currentColor"
                                                   viewBox="0 0 24 24">
                                                   <path
                                                      strokeLinecap="round"
                                                      strokeLinejoin="round"
                                                      strokeWidth={2}
                                                      d="M6 18L18 6M6 6l12 12"
                                                   />
                                                </svg>
                                             </button>
                                          </div>
                                       ) : (
                                          <div className="flex items-center justify-center space-x-3 group">
                                             <h3
                                                className={`text-lg font-bold ml-[44px] ${isDark ? 'text-white' : 'text-gray-800'
                                                   }`}>
                                                {user?.name || 'User Name'}
                                             </h3>
                                             <button
                                                onClick={() => handleEditName()}
                                                className={`opacity-0 opacity-100 p-2 rounded-xl focus:outline-none focus:opacity-100 transition-all duration-200 transform hover:scale-110 ${isDark
                                                   ? 'text-gray-500 text-gray-300 bg-gray-700'
                                                   : 'text-gray-400 text-[#a8e6ac] bg-[#c5f5c8]/10'
                                                   }`}
                                                aria-label="Edit name">
                                                <EditIcon className="w-4 h-4" />
                                             </button>
                                          </div>
                                       )}
                                    </div>

                                    {/* Divider */}
                                    <div className={`border-t ${isDark ? 'border-gray-700' : 'border-gray-200'}`}></div>

                                    {/* Mobile Section */}
                                    <div className="group">
                                       <label
                                          className={`block text-sm font-semibold mb-1 ${isDark ? 'text-gray-300' : 'text-gray-600'
                                             }`}>
                                          Mobile
                                       </label>
                                       {isEditingMobile ? (
                                          <div className="flex items-center space-x-3">
                                             <input
                                                value={editedMobile}
                                                onChange={(e) => setEditedMobile(e.target.value)}
                                                className={`flex-1 p-2.5 backdrop-blur-sm border-2 rounded-xl focus:outline-none focus:ring-4 transition-all duration-200 ${isDark
                                                   ? 'bg-gray-700 border-gray-600 text-white focus:ring-gray-500'
                                                   : 'bg-white/80 border-[#c5f5c8] focus:ring-[#c5f5c8]/20'
                                                   }`}
                                                placeholder="Enter mobile number"
                                             />
                                             <button
                                                onClick={() => handleSaveMobile()}
                                                className={`p-2.5 rounded-xl focus:outline-none focus:ring-4 transition-all duration-200 transform hover:scale-110 ${isDark
                                                   ? 'text-white bg-gradient-to-r from-gray-600 to-gray-700 hover:from-gray-500 hover:to-gray-600 focus:ring-gray-500'
                                                   : 'text-white bg-gradient-to-r from-[#a8e6ac] to-[#c5f5c8] hover:from-[#95d99a] hover:to-[#b8f0bb] focus:ring-[#c5f5c8]/30'
                                                   }`}
                                                aria-label="Save mobile">
                                                <FaCheck className="w-4 h-4" />
                                             </button>
                                             <button
                                                onClick={() => handleCancelEditMobile()}
                                                className={`p-2.5 rounded-xl focus:outline-none focus:ring-4 transition-all duration-200 transform hover:scale-110 ${isDark
                                                   ? 'text-gray-400 hover:text-gray-200 hover:bg-gray-700 focus:ring-gray-600'
                                                   : 'text-gray-500 hover:text-gray-700 hover:bg-gray-100 focus:ring-gray-200'
                                                   }`}
                                                aria-label="Cancel edit">
                                                <svg
                                                   className="w-4 h-4"
                                                   fill="none"
                                                   stroke="currentColor"
                                                   viewBox="0 0 24 24">
                                                   <path
                                                      strokeLinecap="round"
                                                      strokeLinejoin="round"
                                                      strokeWidth={2}
                                                      d="M6 18L18 6M6 6l12 12"
                                                   />
                                                </svg>
                                             </button>
                                          </div>
                                       ) : (
                                          <div
                                             className={`flex items-center justify-between rounded-xl px-4 py-3 border transition-all duration-200 group-hover:border ${isDark
                                                ? 'bg-gray-700 border-gray-600 group-hover:border-gray-500'
                                                : 'bg-white/60 border-gray-200 group-hover:border-[#c5f5c8]/30'
                                                }`}>
                                             <span
                                                className={`font-medium ${isDark ? 'text-gray-200' : 'text-gray-800'}`}>
                                                {user?.mobile || 'No mobile number'}
                                             </span>
                                             <button
                                                onClick={() => handleEditMobile()}
                                                className={`opacity-0 opacity-100 p-2 rounded-lg focus:outline-none focus:opacity-100 transition-all duration-200 transform hover:scale-110 ${isDark
                                                   ? 'text-gray-500 text-gray-300 bg-gray-600'
                                                   : 'text-gray-400 text-[#a8e6ac] bg-[#c5f5c8]/10'
                                                   }`}
                                                aria-label="Edit mobile">
                                                <EditIcon className="w-4 h-4" />
                                             </button>
                                          </div>
                                       )}
                                    </div>

                                    {/* Email Section */}
                                    <div>
                                       <label
                                          className={`block text-sm font-semibold mb-1 ${isDark ? 'text-gray-300' : 'text-gray-600'
                                             }`}>
                                          Email
                                       </label>
                                       <div
                                          className={`rounded-xl px-4 py-3 border ${isDark ? 'bg-gray-700 border-gray-600' : 'bg-gray-100 border-gray-200'
                                             }`}>
                                          <div
                                             className={`font-medium mb-1 ${isDark ? 'text-gray-200' : 'text-gray-700'
                                                }`}>
                                             {user?.email || 'user@example.com'}
                                          </div>
                                          <div
                                             className={`text-xs flex items-center ${isDark ? 'text-gray-400' : 'text-gray-500'
                                                }`}>
                                             <svg className="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
                                                <path
                                                   fillRule="evenodd"
                                                   d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z"
                                                   clipRule="evenodd"
                                                />
                                             </svg>
                                             Email cannot be changed
                                          </div>
                                       </div>
                                    </div>
                                    {user?.packageData?.[0]?.is2stepVerify && (
                                       <div
                                          className={`border-t ${isDark ? 'border-gray-700' : 'border-gray-200'
                                             }`}></div>
                                    )}
                                    {user?.packageData?.[0]?.is2stepVerify && (
                                       <div
                                          className={`rounded-xl px-4 py-3 border ${isDark ? 'bg-gray-700 border-gray-600' : 'bg-white/60 border-gray-200'
                                             }`}>
                                          <div className="flex items-center justify-between">
                                             <div>
                                                <h4
                                                   className={`font-semibold mb-1 ${isDark ? 'text-white' : 'text-gray-800'
                                                      }`}>
                                                   2-Step Verification
                                                </h4>
                                                <p className={`text-sm ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>
                                                   Extra security for your account
                                                </p>
                                             </div>
                                             <div className="relative">
                                                <input
                                                   type="checkbox"
                                                   checked={isTwoFA}
                                                   onChange={(e) => handleToggleTwoFA(e.target.checked)}
                                                   className="sr-only"
                                                   id="twofa-toggle"
                                                />
                                                <label
                                                   htmlFor="twofa-toggle"
                                                   className={`flex items-center cursor-pointer transition-all duration-300 ${isTwoFA
                                                      ? isDark
                                                         ? 'text-green-400'
                                                         : 'text-[#a8e6ac]'
                                                      : 'text-gray-400'
                                                      }`}>
                                                   <div
                                                      className={`relative w-12 h-6 rounded-full transition-all duration-300 ${isTwoFA
                                                         ? isDark
                                                            ? 'bg-gradient-to-r from-green-500 to-green-600'
                                                            : 'bg-gradient-to-r from-[#a8e6ac] to-[#c5f5c8]'
                                                         : isDark
                                                            ? 'bg-gray-600'
                                                            : 'bg-gray-300'
                                                         }`}>
                                                      <div
                                                         className={`absolute top-0.5 left-0.5 w-5 h-5 rounded-full shadow-md transform transition-transform duration-300 ${isDark ? 'bg-gray-300' : 'bg-white'
                                                            } ${isTwoFA ? 'translate-x-6' : 'translate-x-0'}`}></div>
                                                   </div>
                                                </label>
                                             </div>
                                          </div>
                                       </div>
                                    )}

                                    {/* Change Password Button */}
                                    <button
                                       onClick={() => {
                                          setIsOpenProfile(false);
                                          setIsPasswordModalOpen(true);
                                       }}
                                       className={`w-full flex items-center justify-center space-x-3 px-6 py-3 border-2 font-semibold rounded-xl focus:outline-none focus:ring-4 transition-all duration-200 transform hover:scale-105 group ${isDark
                                          ? 'bg-gray-800 border-gray-600 text-gray-300 hover:bg-gray-700 hover:border-gray-500 focus:ring-gray-600'
                                          : 'bg-white border-[#c5f5c8] text-[#a8e6ac] hover:bg-[#c5f5c8]/5 hover:border-[#a8e6ac] focus:ring-[#c5f5c8]/20'
                                          }`}>
                                       <LockIcon className="w-5 h-5 group-hover:scale-110 transition-transform" />
                                       <span>Change Password</span>
                                    </button>
                                 </div>
                              </div>
                           </div>
                        ))}

                     {/* OTP Verification Modal */}
                     {showOtpModal && (
                        <div className="fixed inset-0 z-[70] flex items-center justify-center p-4">
                           {/* Backdrop */}
                           <div
                              className={`absolute inset-0 backdrop-blur-sm transition-all duration-300 ${isDark ? 'bg-black/80' : 'bg-black/70'
                                 }`}
                              onClick={handleCancelOtpVerification}></div>

                           {/* OTP Modal Content */}
                           <div
                              className={`relative rounded-2xl shadow-2xl w-full max-w-sm mx-auto border ${isDark ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-100'
                                 }`}>
                              {/* Modal Header */}
                              <div
                                 className={`px-6 py-4 border rounded-t-2xl ${isDark
                                    ? 'bg-gradient-to-r from-gray-700 to-gray-800 border-gray-700'
                                    : 'bg-gradient-to-r from-[#c5f5c8] to-[#b8f0bb] border-[#c5f5c8]/20'
                                    }`}>
                                 <div className="flex items-center justify-between">
                                    <div>
                                       <h3 className={`text-lg font-bold ${isDark ? 'text-white' : 'text-gray-800'}`}>
                                          Verify Email
                                       </h3>
                                       <p className={`text-sm ${isDark ? 'text-gray-300' : 'text-gray-600'}`}>
                                          Enter the OTP sent to your email
                                       </p>
                                    </div>
                                    <button
                                       onClick={handleCancelOtpVerification}
                                       className={`p-2 rounded-full transition-all duration-200 ${isDark
                                          ? 'text-gray-400 hover:text-gray-200 hover:bg-gray-700'
                                          : 'text-gray-500 hover:text-gray-700 hover:bg-white/50'
                                          }`}>
                                       <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                          <path
                                             strokeLinecap="round"
                                             strokeLinejoin="round"
                                             strokeWidth={2}
                                             d="M6 18L18 6M6 6l12 12"
                                          />
                                       </svg>
                                    </button>
                                 </div>
                              </div>

                              {/* OTP Input Section */}
                              <div className="px-6 py-6 space-y-6">
                                 <div>
                                    <label
                                       className={`block text-sm font-semibold mb-4 text-center ${isDark ? 'text-gray-300' : 'text-gray-600'
                                          }`}>
                                       Enter 6-digit OTP
                                    </label>

                                    {/* OTP Input Boxes */}
                                    <div className="flex justify-center space-x-3 mb-4">
                                       {otpValue.map((digit, index) => (
                                          <input
                                             key={index}
                                             ref={(el) => (otpRefs.current[index] = el)}
                                             type="text"
                                             value={digit}
                                             onChange={(e) => handleOtpChange(index, e.target.value)}
                                             onKeyDown={(e) => handleOtpKeyDown(index, e)}
                                             className={`w-12 h-12 text-center text-xl font-bold border-2 rounded-xl focus:outline-none focus:ring-4 transition-all duration-200 ${isDark
                                                ? 'bg-gray-700 border-gray-600 text-white focus:ring-gray-500 focus:border-gray-400'
                                                : 'bg-gray-50 border-[#c5f5c8] focus:ring-[#c5f5c8]/20 focus:border-[#a8e6ac]'
                                                }`}
                                             maxLength={1}
                                             autoComplete="off"
                                             {...(index === 0 ? { autoFocus: true } : {})}
                                          />
                                       ))}
                                    </div>
                                 </div>

                                 <div className={`text-sm text-center ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>
                                    OTP sent to: {user?.email}
                                 </div>

                                 {/* Action Buttons */}
                                 <div className="flex space-x-3">
                                    <button
                                       onClick={handleCancelOtpVerification}
                                       className={`flex-1 px-4 py-2.5 rounded-xl font-semibold transition-all duration-200 ${isDark
                                          ? 'text-gray-300 bg-gray-700 hover:bg-gray-600'
                                          : 'text-gray-600 bg-gray-100 hover:bg-gray-200'
                                          }`}>
                                       Cancel
                                    </button>
                                    <button
                                       onClick={handleVerifyOtpAndUpdate}
                                       disabled={otpLoading || otpValue.some((digit) => !digit)}
                                       className={`flex-1 px-4 py-2.5 rounded-xl font-semibold transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed ${isDark
                                          ? 'text-white bg-gradient-to-r from-gray-600 to-gray-700 hover:from-gray-500 hover:to-gray-600'
                                          : 'text-black bg-gradient-to-r from-[#a8e6ac] to-[#c5f5c8] hover:from-[#95d99a] hover:to-[#b8f0bb]'
                                          }`}>
                                       {otpLoading ? (
                                          <div className="flex items-center justify-center">
                                             <div
                                                className={`w-4 h-4 border-2 rounded-full animate-spin mr-2 ${isDark
                                                   ? 'border-white border-t-transparent'
                                                   : 'border-black border-t-transparent'
                                                   }`}></div>
                                             Verifying...
                                          </div>
                                       ) : (
                                          'Verify & Update'
                                       )}
                                    </button>
                                 </div>

                                 {/* Resend OTP */}
                                 <div className="text-center">
                                    <button
                                       onClick={async () => {
                                          try {
                                             await dispatch(
                                                sendOtpInEmailOrNo({
                                                   email: user?.email,
                                                   sendType: 0,
                                                }),
                                             );
                                             setOtpValue(['', '', '', '', '', '']); // Reset OTP
                                             otpRefs.current[0]?.focus(); // Focus first input
                                             toast({
                                                title: 'OTP Resent',
                                                description: 'New OTP sent to your email',
                                                status: 'success',
                                                duration: 3000,
                                                isClosable: true,
                                             });
                                          } catch (error) {
                                             toast({
                                                title: 'Error',
                                                description: 'Failed to resend OTP',
                                                status: 'error',
                                                duration: 3000,
                                                isClosable: true,
                                             });
                                          }
                                       }}
                                       className={`text-sm font-semibold transition-colors duration-200 ${isDark
                                          ? 'text-green-400 hover:text-green-300'
                                          : 'text-[#a8e6ac] hover:text-[#95d99a]'
                                          }`}>
                                       Resend OTP
                                    </button>
                                 </div>
                              </div>
                           </div>
                        </div>
                     )}

                     {/* Password Change Modal */}
                     {isPasswordModalOpen && (
                        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
                           {/* Backdrop */}
                           <div
                              className={`absolute inset-0 backdrop-blur-sm transition-all duration-300 ${isDark ? 'bg-black/70' : 'bg-black/60'
                                 }`}
                              onClick={handlePasswordModalClose}></div>

                           {/* Modal Content */}
                           <div
                              className={`relative rounded-2xl shadow-2xl w-full max-w-md mx-auto max-h-[90vh] overflow-hidden border ${isDark ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-100'
                                 }`}>
                              {/* Modal Header */}
                              <div
                                 className={`relative px-8 py-6 border-b ${isDark
                                    ? 'bg-gradient-to-r from-gray-700 to-gray-800 border-gray-700'
                                    : 'bg-gradient-to-r from-[#c5f5c8] to-[#b8f0bb] border-[#c5f5c8]/20'
                                    }`}>
                                 <div className="flex items-start justify-between">
                                    <div>
                                       <h2
                                          className={`text-2xl font-bold mb-1 ${isDark ? 'text-white' : 'text-gray-800'
                                             }`}>
                                          Change Password
                                       </h2>
                                       <p
                                          className={`text-sm font-medium ${isDark ? 'text-gray-300' : 'text-gray-600'
                                             }`}>
                                          Update your account password securely
                                       </p>
                                    </div>
                                    <button
                                       onClick={handlePasswordModalClose}
                                       className={`ml-4 p-2 rounded-full transition-all duration-200 group ${isDark
                                          ? 'text-gray-400 hover:text-gray-200 hover:bg-gray-700'
                                          : 'text-gray-500 hover:text-gray-700 hover:bg-white/50'
                                          }`}>
                                       <svg
                                          className="w-5 h-5 group-hover:scale-110 transition-transform"
                                          fill="none"
                                          stroke="currentColor"
                                          viewBox="0 0 24 24">
                                          <path
                                             strokeLinecap="round"
                                             strokeLinejoin="round"
                                             strokeWidth={2}
                                             d="M6 18L18 6M6 6l12 12"
                                          />
                                       </svg>
                                    </button>
                                 </div>
                                 {/* Decorative element */}
                                 <div
                                    className={`absolute bottom-0 left-8 right-8 h-0.5 ${isDark
                                       ? 'bg-gradient-to-r from-gray-600 via-gray-500 to-gray-600'
                                       : 'bg-gradient-to-r from-[#c5f5c8] via-[#a8e6ac] to-[#c5f5c8]'
                                       }`}></div>
                              </div>

                              {/* Modal Body */}
                              <div className="px-6 py-4">
                                 <div className="space-y-4">
                                    {/* Current Password Field */}
                                    <div>
                                       <label
                                          className={`block text-sm font-medium mb-1 ${isDark ? 'text-gray-300' : 'text-gray-700'
                                             }`}>
                                          Current Password
                                       </label>
                                       <div className="relative">
                                          <input
                                             type={showPasswords.old ? 'text' : 'password'}
                                             value={passwordData.oldPassword}
                                             onChange={(e) => handlePasswordChange('oldPassword', e.target.value)}
                                             placeholder="Enter your current password"
                                             className={`w-full px-3 py-2 pr-10 border rounded-md focus:outline-none focus:ring-2 focus:border-transparent transition-colors duration-200 ${passwordErrors.oldPassword
                                                ? isDark
                                                   ? 'border-red-500 focus:ring-red-500'
                                                   : 'border-red-300 focus:ring-red-500'
                                                : isDark
                                                   ? 'border-gray-600 bg-gray-700 text-white focus:ring-blue-500 focus:border-blue-500'
                                                   : 'border-gray-300 focus:ring-blue-500'
                                                }`}
                                          />
                                          <div className="absolute inset-y-0 right-0 flex items-center pr-3">
                                             <button
                                                type="button"
                                                onClick={() => togglePasswordVisibility('old')}
                                                className={`focus:outline-none transition-colors duration-200 ${isDark
                                                   ? 'text-gray-400 hover:text-gray-200'
                                                   : 'text-gray-400 hover:text-gray-600'
                                                   }`}
                                                aria-label={showPasswords.old ? 'Hide password' : 'Show password'}>
                                                {showPasswords.old ? (
                                                   <FaEyeSlash className="w-4 h-4" />
                                                ) : (
                                                   <FaEye className="w-4 h-4" />
                                                )}
                                             </button>
                                          </div>
                                       </div>
                                       {passwordErrors.oldPassword && (
                                          <p className="mt-1 text-sm text-red-500">{passwordErrors.oldPassword}</p>
                                       )}
                                    </div>

                                    {/* New Password Field */}
                                    <div>
                                       <label
                                          className={`block text-sm font-medium mb-1 ${isDark ? 'text-gray-300' : 'text-gray-700'
                                             }`}>
                                          New Password
                                       </label>
                                       <div className="relative">
                                          <input
                                             type={showPasswords.new ? 'text' : 'password'}
                                             value={passwordData.newPassword}
                                             onChange={(e) => handlePasswordChange('newPassword', e.target.value)}
                                             placeholder="Enter your new password"
                                             className={`w-full px-3 py-2 pr-10 border rounded-md focus:outline-none focus:ring-2 focus:border-transparent transition-colors duration-200 ${passwordErrors.newPassword
                                                ? isDark
                                                   ? 'border-red-500 focus:ring-red-500'
                                                   : 'border-red-300 focus:ring-red-500'
                                                : isDark
                                                   ? 'border-gray-600 bg-gray-700 text-white focus:ring-blue-500 focus:border-blue-500'
                                                   : 'border-gray-300 focus:ring-blue-500'
                                                }`}
                                          />
                                          <div className="absolute inset-y-0 right-0 flex items-center pr-3">
                                             <button
                                                type="button"
                                                onClick={() => togglePasswordVisibility('new')}
                                                className={`focus:outline-none transition-colors duration-200 ${isDark
                                                   ? 'text-gray-400 hover:text-gray-200'
                                                   : 'text-gray-400 hover:text-gray-600'
                                                   }`}
                                                aria-label={showPasswords.new ? 'Hide password' : 'Show password'}>
                                                {showPasswords.new ? (
                                                   <FaEyeSlash className="w-4 h-4" />
                                                ) : (
                                                   <FaEye className="w-4 h-4" />
                                                )}
                                             </button>
                                          </div>
                                       </div>
                                       {passwordErrors.newPassword && (
                                          <p className="mt-1 text-sm text-red-500">{passwordErrors.newPassword}</p>
                                       )}
                                    </div>

                                    {/* Confirm Password Field */}
                                    <div>
                                       <label
                                          className={`block text-sm font-medium mb-1 ${isDark ? 'text-gray-300' : 'text-gray-700'
                                             }`}>
                                          Confirm New Password
                                       </label>
                                       <div className="relative">
                                          <input
                                             type={showPasswords.confirm ? 'text' : 'password'}
                                             value={passwordData.confirmPassword}
                                             onChange={(e) => handlePasswordChange('confirmPassword', e.target.value)}
                                             placeholder="Confirm your new password"
                                             className={`w-full px-3 py-2 pr-10 border rounded-md focus:outline-none focus:ring-2 focus:border-transparent transition-colors duration-200 ${passwordErrors.confirmPassword
                                                ? isDark
                                                   ? 'border-red-500 focus:ring-red-500'
                                                   : 'border-red-300 focus:ring-red-500'
                                                : isDark
                                                   ? 'border-gray-600 bg-gray-700 text-white focus:ring-blue-500 focus:border-blue-500'
                                                   : 'border-gray-300 focus:ring-blue-500'
                                                }`}
                                          />
                                          <div className="absolute inset-y-0 right-0 flex items-center pr-3">
                                             <button
                                                type="button"
                                                onClick={() => togglePasswordVisibility('confirm')}
                                                className={`focus:outline-none transition-colors duration-200 ${isDark
                                                   ? 'text-gray-400 hover:text-gray-200'
                                                   : 'text-gray-400 hover:text-gray-600'
                                                   }`}
                                                aria-label={showPasswords.confirm ? 'Hide password' : 'Show password'}>
                                                {showPasswords.confirm ? (
                                                   <FaEyeSlash className="w-4 h-4" />
                                                ) : (
                                                   <FaEye className="w-4 h-4" />
                                                )}
                                             </button>
                                          </div>
                                       </div>
                                       {passwordErrors.confirmPassword && (
                                          <p className="mt-1 text-sm text-red-500">{passwordErrors.confirmPassword}</p>
                                       )}
                                    </div>
                                 </div>
                              </div>

                              {/* Modal Footer */}
                              <div
                                 className={`px-8 py-6 border-t flex justify-end space-x-4 ${isDark ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-100'
                                    }`}>
                                 <button
                                    onClick={handlePasswordModalClose}
                                    className={`px-6 py-2.5 text-sm font-semibold border-2 rounded-xl focus:outline-none focus:ring-4 transition-all duration-200 transform hover:scale-105 ${isDark
                                       ? 'text-gray-300 bg-gray-700 border-gray-600 hover:bg-gray-600 hover:border-gray-500 focus:ring-gray-600'
                                       : 'text-gray-600 bg-gray-100 border-gray-200 hover:bg-gray-200 hover:border-gray-300 focus:ring-gray-200'
                                       }`}>
                                    Cancel
                                 </button>
                                 <button
                                    onClick={handlePasswordSubmit}
                                    disabled={isSubmitting}
                                    className={`relative px-8 py-2.5 text-sm font-semibold border-2 rounded-xl focus:outline-none focus:ring-4 disabled:opacity-60 disabled:cursor-not-allowed disabled:hover:scale-100 transition-all duration-200 transform hover:scale-105 shadow-lg hover:shadow-xl overflow-hidden ${isDark
                                       ? 'text-white bg-gradient-to-r from-gray-600 to-gray-700 border-gray-600 hover:from-gray-500 hover:to-gray-600 focus:ring-gray-500'
                                       : 'text-white bg-gradient-to-r from-[#a8e6ac] to-[#c5f5c8] border-[#c5f5c8] hover:from-[#95d99a] hover:to-[#b8f0bb] focus:ring-[#c5f5c8]/30'
                                       }`}>
                                    {/* Shimmer effect */}
                                    <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full hover:translate-x-full transition-transform duration-700"></div>

                                    {isSubmitting ? (
                                       <span className="flex items-center relative z-10">
                                          <svg className="w-4 h-4 mr-2 animate-spin" fill="none" viewBox="0 0 24 24">
                                             <circle
                                                className="opacity-25"
                                                cx="12"
                                                cy="12"
                                                r="10"
                                                stroke="currentColor"
                                                strokeWidth="4"></circle>
                                             <path
                                                className="opacity-75"
                                                fill="currentColor"
                                                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                          </svg>
                                          Updating...
                                       </span>
                                    ) : (
                                       <span className="relative z-10 flex items-center">
                                          <svg
                                             className="w-4 h-4 mr-2"
                                             fill="none"
                                             stroke="currentColor"
                                             viewBox="0 0 24 24">
                                             <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth={2}
                                                d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                                             />
                                          </svg>
                                          Update Password
                                       </span>
                                    )}
                                 </button>
                              </div>
                           </div>
                        </div>
                     )}
                  </Box>
               </Flex>
            </Flex>
         </Flex>
         {isFeedbackOpen && (
            <Flex alignContent="end" justifyContent="center">
               <Drawer
                  isOpen={isFeedbackOpen}
                  placement="right"
                  onClose={handleCloseModal}
                  finalFocusRef={imageModalRef}
                  size="md">
                  <DrawerContent
                     className={`${isDark ? 'bg-gray-800' : 'bg-white'} transition-transform duration-500 ease-out`}
                     sx={{
                        maxWidth: '450px',
                        borderRadius: '10px',
                        marginTop: '60px',
                        height: '450px',
                        marginRight: { base: '0px', md: '20px' },
                     }}
                     transform={isOpen ? 'translateX(0)' : 'translateX(90%)'}>
                     <DrawerBody>
                        <FeedbackForm
                           onClose={handleCloseModal}
                           imageModalRef={imageModalRef}
                           isFeedbackOpen={isFeedbackOpen}
                           setIsFeedbackOpen={setIsFeedbackOpen}
                        />
                     </DrawerBody>
                  </DrawerContent>
               </Drawer>
            </Flex>
         )}

         {isNotifyMeOpen && (
            <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-[990]">
               <NotifyMe onClose={() => setIsNotifyMeOpen(false)} />
            </div>
         )}

         {isNotification && (
            <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-[990]">
               <Notification
                  onClose={() => setIsNotification(false)}
                  NotificationData={notificationData}
                  Paginationdata={Paginationdata}
               />
            </div>
         )}

         {showUpgrade && (
            <div className="fixed inset-0 z-[1001]">
               <PlanCarousel
                  PackageData={PackageData}
                  currentPlan={currentPlan}
                  onUpgrade={handleUpgrade}
                  onClose={() => setShowUpgrade(false)}
                  isExpired={isExpired}
               />
            </div>
         )}
      </>
   );
}

HeaderLinks.propTypes = {
   variant: PropTypes.string,
   fixed: PropTypes.bool,
   secondary: PropTypes.bool,
   onOpen: PropTypes.func,
   isSidebarOpen: PropTypes.bool,
};
